__turbopack_context__.v({
  "avatar": "ebBDPW_avatar",
  "bars": "ebBDPW_bars",
  "barsLayer": "ebBDPW_barsLayer",
  "bubble": "ebBDPW_bubble",
  "bubblePlay": "ebBDPW_bubblePlay",
  "bubbleTime": "ebBDPW_bubbleTime",
  "bubbleWave": "ebBDPW_bubbleWave",
  "capsule": "ebBDPW_capsule",
  "capsuleRow": "ebBDPW_capsuleRow",
  "composer": "ebBDPW_composer",
  "discard": "ebBDPW_discard",
  "error": "ebBDPW_error",
  "hint": "ebBDPW_hint",
  "live": "ebBDPW_live",
  "message": "ebBDPW_message",
  "messageBody": "ebBDPW_messageBody",
  "meta": "ebBDPW_meta",
  "mic": "ebBDPW_mic",
  "rec": "ebBDPW_rec",
  "recDot": "ebBDPW_recDot",
  "reviewPlay": "ebBDPW_reviewPlay",
  "reviewWave": "ebBDPW_reviewWave",
  "root": "ebBDPW_root",
  "send": "ebBDPW_send",
  "srOnly": "ebBDPW_srOnly",
  "stop": "ebBDPW_stop",
  "thread": "ebBDPW_thread",
  "timer": "ebBDPW_timer",
});
